// extracted by mini-css-extract-plugin
export default {"betOrderRecords":"betOrderRecords_betOrderRecords__8TSm5","title":"betOrderRecords_title__VEeU4","venue":"betOrderRecords_venue__I35Kv"};